<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl6 lg6 xs12>
                        <v-text-field
                          v-model="filter.usrId"
                          :label="label.usrId"
                          :error-messages="errors.collect('filter.usrId')"
                          data-vv-name="filter.usrId"
                          :data-vv-as="label.usrId"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl6 lg6 xs12>
                        <v-text-field
                          v-model="filter.name"
                          :label="label.name"
                          :error-messages="errors.collect('filter.name')"
                          data-vv-name="filter.name"
                          :data-vv-as="label.name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl6 lg6 xs12>
                        <v-text-field
                          v-model="filter.cls"
                          :label="label.cls"
                          :error-messages="errors.collect('filter.cls')"
                          data-vv-name="filter.cls"
                          :data-vv-as="label.cls"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <v-flex xs12>
          <v-card>
              <v-flex xs12>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark class=" mr-2" @click="doNew">
                    New Claims Limit
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      :server-items-length="totalItems"
                      v-bind:options.sync="pagination"
                      item-key="name1"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td class="text-xs-left">{{ row.item.usrId }}</td>
                          <td class="text-xs-left">{{ row.item.name }}</td>
                          <td class="text-xs-left">{{ row.item.cls }}</td>
                          <td class="text-right">{{ formatDisplayNumber(row.item.maxRes) }}</td>
                          <td class="text-right">{{ formatDisplayNumber(row.item.maxPayt) }}</td>
                          <td class="text-right">{{ formatDisplayNumber(row.item.maxInc) }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              query
                              @query="doQuery(row.item)"
                              review
                              @review="doReview(row.item)"
                              remove
                              @remove="doPromptRemove(row.item)"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-flex>
          </v-card>
        </v-flex>
      </v-card>
    </v-flex>
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete the selected Limit?</p>
      <div class="queryValue">User ID: {{ selected.usrId }}</div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayNumber } from '@/utils/number'
import clone from 'clone'

export default {
  data() {
    return {
      headers: [
        { text: 'User ID', value: 'usrId' },
        { text: 'User Name', value: 'name' },
        { text: 'Business Class', value: 'cls' },
        { text: 'Maximum Reserve', value: 'maxRes' },
        { text: 'Maximum Payment', value: 'maxPayt' },
        { text: 'Maximum Incurred', value: 'maxInc' },
        TableConst.tableActionHeader
      ],
      selected: {
        usrId: null,
        cls: null
      },
      sideFunction: [
        {
          text: 'Permit Zone',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'ctyZoneList' }
        },
        {
          text: 'Region',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'regionList' }
        }
      ],
      promptRemove: false,
      label: {
        usrId: 'User ID',
        name: 'User Name',
        cls: 'Business Class'
      },
      filter: {
        usrId: null,
        name: null,
        cls: null
      },
      toogleArray: [false],
      tranMode: null,
      totalItems: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.getUsrClmLimList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: false
          }
          let messageFilters = clone(this.filter)
          // console.log(this.pagination.sortBy)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((usrClmLim) => {
                const convertList = {
                  usrId: usrClmLim.usrId,
                  cls: usrClmLim.cls,
                  name: usrClmLim.name,
                  maxRes: usrClmLim.maxRes,
                  maxPayt: usrClmLim.maxPayt,
                  maxInc: usrClmLim.maxInc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.$router.push({ name: 'usrClmLimReview', params: { paramMode: 'new' } })
    },
    doReview(obj) {
      this.$router.push({ name: 'usrClmLimReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        this.promptRemove = true
        this.selected.usrId = data.usrId
        this.selected.cls = data.cls
      }
    },
    doDelete() {
      if (this.selected.usrId) {
        const apiURI = this.menu.delete
        if (apiURI) {
          const expand = {
            usrId: this.selected.usrId,
            cls: this.selected.cls
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.doInit(true)
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doClearFilters() {
      this.filter.usrId = null
      this.filter.name = null
      this.filter.cls = null
      this.doInit()
    },
    doFilters() {
      this.doInit()
    },
    doQuery(obj) {
      this.$router.push({ name: 'usrClmLimReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  computed: {
    menu() {
      return this.$store.state.usrClmLimParam.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit()
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
